export default __webpack_public_path__ + "static/media/Icon=Roles.d71a3c6e.svg";